import { render, staticRenderFns } from "./Seguridad.vue?vue&type=template&id=0712e4f5"
import script from "./Seguridad.vue?vue&type=script&lang=js"
export * from "./Seguridad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports